<script>
import api from '@utils/api'
import * as compare from '@utils/comparers'
import { createBarcodeScanner, isMobile } from '@utils/barcode/barcode-scanner'
import { sortBy } from 'lodash'

export default {
  name: 'DocumentReturnsNew',
  props: {
    dialog: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      serialLoading: false,
      valid: true,
      document: null,
      serial: null,
      currentSerial: null,
      serialList: [],
      article: null,
      from: null,
      fromWarehouse: null,
      to: null,
      toOrganizations: [],
      toOrganizationsLoading: false,
      toWarehouse: null,
      toWarehouseLoading: false,
      warehouseList: [],
      rules: {
        isRequired: [x => !!x || this.$t('validation__is_required')],
      },
      serialNumbers: [],
      documentList: [],
      scannerIsVisible: false,
      barcodeScanner: createBarcodeScanner(document),
      isMobile: isMobile(),
    }
  },
  watch: {
    article(value) {
      this.from = null
      this.fromWarehouse = null
      this.currentSerial = this.serialList.find(item => item.goodsId === value)
      if (this.currentSerial) {
        this.from = this.currentSerial.organizationId
        this.fromWarehouse = this.currentSerial.warehouseId
      }
    },
    dialog(value) {
      if (value) {
        this.getOrganizations()
      }
    },
    to(value) {
      if (!value) {
        this.warehouseList = []
        this.toWarehouse = null
      } else {
        this.toWarehouseLoading = true
        api
          .getOrganizationChild(value)
          .then(response => {
            this.warehouseList = response.sort(compare.byShortName)
            if (response.length === 1) this.toWarehouse = response[0].id
            else {
              const organization = this.$store.getters[
                'data/getOrganization'
              ].find(elem => elem.id === value)
              const mainWarehouseId = organization.mainWarehouse || null
              if (mainWarehouseId) {
                const main = response.find(elem => elem.id === mainWarehouseId)
                if (main) this.toWarehouse = main.id
              }
            }
            this.toWarehouseLoading = false
          })
          .catch(() => {})
          .then(() => {
            this.toWarehouseLoading = false
          })
      }
    },
  },
  methods: {
    checkSerial() {
      this.serialLoading = true
      api
        .getGoodsBySerial({
          serial: this.serial,
          in_my_organization: false,
        })
        .then(response => {
          this.serialList = sortBy(response.data)
          if (response.data.length === 1)
            this.article = response.data[0].goodsId
          this.serialLoading = false
        })
        .catch(() => {})
        .then(() => {
          this.serialLoading = false
        })
    },
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    close() {
      this.$refs.newItemForm.reset()
      this.loading = false
      this.serialLoading = false
      this.valid = true
      this.document = null
      this.serial = null
      this.currentSerial = null
      this.serialList = []
      this.article = null
      this.from = null
      this.fromWarehouse = null
      this.to = null
      this.toWarehouse = null
      this.toWarehouseLoading = false
      this.warehouseList = []
      this.serialNumbers = []
      this.documentList = []
      this.$emit('close-modal')
    },
    create() {
      if (this.$refs.newItemForm.validate()) {
        this.loading = true
        const document = this.documentList.find(
          item => item.fromWarehouse === this.fromWarehouse
        )
        if (document) {
          api
            .createItem('documentspecification', {
              document: document.id,
              goods: this.article,
              serial: this.serial,
              quantity: 1,
              unit: 104,
            })
            .then(response => {
              api
                .getSerialNumbers(
                  this.fromWarehouse,
                  this.currentSerial.groupCode
                )
                .then(response => {
                  this.serial = null
                  this.serialNumbers = response
                  if (response.length === 1) this.serial = response[0]
                  this.$emit('add-document')
                  this.loading = false
                  this.$store.commit('notifications/ADD', {
                    type: 'success',
                    message: this.$t('message__spec_added'),
                  })
                  let to = this.to
                  let toWarehouse = this.toWarehouse
                  this.$refs.newItemForm.reset()
                  this.to = to
                  this.toWarehouse = toWarehouse
                })
            })
        } else {
          api
            .createItem('document', {
              type: 6,
              from: this.from,
              fromWarehouse: this.fromWarehouse,
              to: this.to,
              toWarehouse: this.toWarehouse,
            })
            .then(response => {
              this.document = response.id
              this.documentList.push(response)
              api
                .createItem('documentspecification', {
                  document: this.document,
                  goods: this.article,
                  serial: this.serial,
                  quantity: 1,
                  unit: 104,
                })
                .then(() => {
                  api
                    .getSerialNumbers(
                      this.fromWarehouse,
                      this.currentSerial.groupCode
                    )
                    .then(response => {
                      this.serial = null
                      this.serialNumbers = response
                      if (response.length === 1) this.serial = response[0]
                      this.$emit('add-document')
                      this.loading = false
                      this.$store.commit('notifications/ADD', {
                        type: 'success',
                        message: this.$t('message__document_created'),
                      })
                      let to = this.to
                      let toWarehouse = this.toWarehouse
                      this.$refs.newItemForm.reset()
                      this.to = to
                      this.toWarehouse = toWarehouse
                    })
                })
            })
            .catch(() => {})
            .then(() => {
              this.loading = false
            })
        }
      }
    },
    getOrganizations() {
      const myOrganizationId = this.$store.state.data.myOrganization
      const myOrganizations = this.$store.getters['data/getOrganization'].find(
        elem => elem.id === myOrganizationId
      )
      this.to = myOrganizationId
      this.toOrganizations.push(myOrganizations)
    },
    openBarcodeScanner(field, applyFnValue) {
      this.scannerIsVisible = true
      this.barcodeScanner.openScannerForField(
        value => applyFnValue(value),
        () => this.closeScanner()
      )
    },
    setSerial(value) {
      this.serial = value
      this.checkSerial()
    },
    closeScanner() {
      this.barcodeScanner.closeScanner()
      this.scannerIsVisible = false
    },
    async createAndFinalize() {
      if (this.$refs.newItemForm.validate()) {
        this.loading = true
        const document = this.documentList.find(
          item => item.fromWarehouse === this.fromWarehouse
        )
        if (document) {
          api
            .createItem('documentspecification', {
              document: document.id,
              goods: this.article,
              serial: this.serial,
              quantity: 1,
              unit: 104,
            })
            .then(response => {
              api
                .getSerialNumbers(
                  this.fromWarehouse,
                  this.currentSerial.groupCode
                )
                .then(response => {
                  this.serial = null
                  this.serialNumbers = response
                  if (response.length === 1) {
                    this.serial = response[0]
                  }
                })
                .catch(() => {})
                .then(() => this.finalize(document))
            })
        } else {
          api
            .createItem('document', {
              type: 6,
              from: this.from,
              fromWarehouse: this.fromWarehouse,
              to: this.to,
              toWarehouse: this.toWarehouse,
            })
            .then(response => {
              let document = response
              api
                .createItem('documentspecification', {
                  document: document.id,
                  goods: this.article,
                  serial: this.serial,
                  quantity: 1,
                  unit: 104,
                })
                .then(() => {
                  api
                    .getSerialNumbers(
                      this.fromWarehouse,
                      this.currentSerial.groupCode
                    )
                    .then(response => {
                      this.serial = null
                      this.serialNumbers = response
                      if (response.length === 1) {
                        this.serial = response[0]
                      }
                    })
                    .catch(() => {})
                    .then(() => {
                      this.finalize(document)
                    })
                })
            })
            .catch(() => {})
        }
      }
    },
    async finalize(document) {
      return api
        .finalizeDocument(document.id)
        .catch(() => {})
        .then(() => {
          this.$emit('add-document')
          this.$store.commit('notifications/ADD', {
            type: 'success',
            message: this.$t('message__document_created'),
          })
          let to = this.to
          let toWarehouse = this.toWarehouse
          this.$refs.newItemForm.reset()
          this.to = to
          this.toWarehouse = toWarehouse
          this.loading = false
          this.documentList = this.documentList.filter(
            doc => doc.id !== document.id
          )
        })
    },
  },
}
</script>

<template>
  <v-dialog 
    v-model="dialog" 
    :content-class="$style.relativePosition"
    persistent
    max-width="500px">
    <v-card>
      <v-card-title>
        <v-spacer />
        <div class="headline">{{ $t('titles__new_document') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex 
              xs12 
              class="text-xs-center">
              <v-form 
                ref="newItemForm" 
                v-model="valid" 
                lazy-validation>
                <v-layout 
                  row 
                  align-center>
                  <v-flex>
                    <v-text-field
                      :label="$t('label__serial')"
                      v-model="serial"
                      :rules="rules.isRequired"
                      :disabled="serialLoading"
                      required
                      @keyup.enter="checkSerial()"
                    />
                  </v-flex>
                  <v-flex shrink>
                    <v-btn
                      :disabled="serialLoading"
                      :loading="serialLoading"
                      color="primary"
                      flat
                      icon
                      @click.prevent="checkSerial()"
                    >
                      <v-icon>get_app</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex
                    v-if="isMobile"
                    shrink>
                    <img
                      :class="['barcodeScanIcon', serialLoading ? 'imageDisabled' : '' ]"
                      src="@assets/images/barcode_scan_icon.png"
                      @click="openBarcodeScanner('serial', setSerial)"
                    >
                  </v-flex>
                </v-layout>
                <v-select
                  :items="serialList"
                  :label="$t('label__article')"
                  v-model="article"
                  :rules="rules.isRequired"
                  :disabled="!serialList.length < 2"
                  item-text="goodsShortName"
                  item-value="goodsId"
                  required
                  autocomplete
                />
                <v-text-field
                  :label="$t('label__from')"
                  :value="getValue('organization', from)"
                  :rules="rules.isRequired"
                  required
                  disabled
                />
                <v-text-field
                  :label="$t('label__fromWarehouse')"
                  :value="getValue('organization', fromWarehouse)"
                  :rules="rules.isRequired"
                  required
                  disabled
                />
                <v-select
                  :items="toOrganizations"
                  :label="$t('label__to')"
                  :rules="rules.isRequired"
                  :loading="toOrganizationsLoading"
                  v-model="to"
                  item-text="shortName"
                  item-value="id"
                  required
                  autocomplete
                />
                <v-select
                  :items="warehouseList"
                  :label="$t('label__toWarehouse')"
                  :rules="rules.isRequired"
                  :loading="toWarehouseLoading"
                  v-model="toWarehouse"
                  item-text="shortName"
                  item-value="id"
                  required
                  autocomplete
                />
              </v-form>
            </v-flex>
            <small>* {{ $t('label__requier_small_text') }}</small>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn 
          :disabled="loading" 
          color="secondary" 
          @click="close()">{{
            $t('buttons__close')
          }}</v-btn>
        <v-btn
          :disabled="loading"
          :loading="loading"
          color="primary"
          @click="create()"
        >{{ $t('buttons__create_as_draft') }}</v-btn
        >
        <v-btn
          :disabled="loading"
          :loading="loading"
          color="primary"
          @click="createAndFinalize()"
        >{{ $t('buttons__finalize') }}</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-card
      v-show="scannerIsVisible"
      id="scanner-container"
      class="scannerContainer">
      <v-btn
        class="scannerCancelBtn"
        color="secondary"
        @click="closeScanner()"
      >
        {{ $t('buttons__cancel') }}
      </v-btn>
    </v-card>
    <div
      v-if="scannerIsVisible"
      class="blurred"/>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';

.relativePosition {
  position: relative;
}
</style>
